export const sortByQuery = (arr, objKey, query) => {
  const q = query.toLocaleLowerCase()
  function rank (uName) {
    const n = uName.toLocaleLowerCase()
    if (n === q) return 0
    if (n.startsWith(q)) return 1
    if (n.includes(q)) return 2
    return 3
  }

  return [...arr].sort((a, b) => {
    const rA = rank(a[objKey])
    const rB = rank(b[objKey])
    if (rA !== rB) return rA - rB
    return a[objKey].localeCompare(b[objKey], 'pt-BR')
  })
}
